import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-question-formats/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const questionFormats = {
  getAll: apiPathFunc(pathBase),
} as const;
